//     importing images / icons
import headerIcon from "./assets/images/headerIcon.png";
import allWarriors from "./assets/images/allWarriors.png";
import storyBehind from "./assets/images/storyBehind.png";
import warrior from "./assets/images/warrior.png";
import bossNFT from "./assets/images/bossNFT.png";
import communityBg from "./assets/images/communityBg.png";
import nft from "./assets/images/NFT.png";
import discord from "./assets/images/discord.svg";
import ethereum from "./assets/images/ethereum.svg";
import arrow from "./assets/images/up-arrow-upload-svgrepo-com.svg";
import BarsIcon from "./assets/images/barsIcon.png"
//     importing css files
import "./App.css";
import { useState } from "react";

function App() {
  const [toggle,setToggle]= useState(false)
  return (
    <>
      <a
        // href="/#"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="z-50 animate-bounce fixed right-8 cursor-pointer bottom-0  w-24 h-24 px-5 py-2 text-lg leading-5 rounded-none font-semibold text-white my-8"
      >
        <div className="align-center">
          <img
            src={arrow}
            className="min-w-screen mix-blend-multiply ml-5 h-16"
            alt="arrow"
          />
        </div>
      </a>
      {
        <nav className="absolute top-0 z-50 font-['Sukhumvit Set'] bg-transparent inset-x-0">
          <div className="min-w-screen amx-auto px-4">
            <div className=" grid grid-cols-12 gap-4 md:grid-cols-4 md:justify-around">
              <div className="col-span-3">
                {/* <!-- logo --> */}
                <a
                  href="/#"
                  className="flex items-center w-[250px] h-[120px] justify-start"
                >
                  <img
                    src={headerIcon}
                    className="w-[250px] h-[120px]"
                    alt="headerIcon"
                  />
                </a>
              </div>
              {/* <!-- secondary nav --> */}
              <div className="flex my-auto h-max md:hidden items-center col-span-9 text-white text-xl justify-evenly font-medium">
                <a href="/#about_section" className="py-5 px-3">
                  About
                </a>
                <a href="/#nft_section" className="py-5 px-3">
                  NFTs
                </a>
                <a href="/#story_section" className="py-5 px-3">
                  Story
                </a>
                <a href="/#roadmap_section" className="py-5 px-3">
                  Roadmap
                </a>
              </div>
              {/* <!-- mobile button goes here --> */}
              <div className="hidden md:block my-auto ml-auto mr-[18%]">
                <button onClick={()=>setToggle(!toggle)} className=" cursor-pointer border-2 border-[#57B8FF] bg-[#57B8FF] rounded-[7px] w-[40px] h-[40px] text-[white] focus:outline-none">
                  <img src={BarsIcon} alt=""/>
                  {/* <i className="bx bx-menu text-3xl mt-1"></i> */}
                </button>
              </div>
              <div className={toggle?"hidden duration-500 transition-all absolute pl-[50px] bg-[#57B8FF]  bg-opacity-90 w-[86%] left-[7%] right-[7%]  top-[100px] flex-col md:flex items-left col-span-9 text-white  font-medium":"hidden"}>
                <a href="/#about_section" className="py-1">
                  About
                </a>
                <a href="/#nft_section" className="py-1">
                  NFTs
                </a>
                <a href="/#story_section" className="py-1">
                  Story
                </a>
                <a href="/#roadmap_section" className="py-1">
                  Roadmap
                </a>
              </div>
            </div>
          </div>
        </nav>
      }

      <div className="text-center font-['Sukhumvit'] flex flex-col">
        <div className="relative min-w-screen min-h-screen flex flex-row w-full text-left ">
          <div className="bg-[url('./assets/images/frogBg.png')] pt-[12%] pb-[12%] bg-cover min-h-screen w-[63%] xl:w-[73%] lg:w-[100%] flex justify-start items-center ">
            <div className="w-full ml-[102px] pt-[10%] pb-[10%] md:m-0 md:p-[10%] md:pb-0 md:pt-[80px]">
              <p className="not-italic text-[22px] font-[800] leading-[25px] text-[#56B8FF] pb-[13px]">
                Now in Digital
              </p>
              <p className="not-italic font-semibold text-[75px] leading-[88px] Toppan-text text-[#FFFFFF] pb-[47px] xl:text-[45px] xl:leading-[55px] md:text-[28px] md:leading-[36px]">
                Cyber Warriors <br /> Attack !
              </p>
              <p className="not-italic font-[800] max-w-[450px] text-[22px] leading-[26px] text-[#FFFFFF] pb-[103px] md:pb-[50px] sm:text-[18px]">
                Lorem ipsum dolor amet, consectetur 
                {/* <br /> */}
                 &nbsp; adipiscing elit. Eget nisl nunc quam ac sed
                {/* <br /> */}
                 turpis volutpat. Cursus sed massa non .
              </p>
              <button className="h-[97px] w-[281px] md:h-[50px] md:w-[200px] bg-[#57B8FF]">
                <span className="not-italic font-[800] text-[27px] md:text-[20px] leading-[32px] text-center">
                  <a href="https://teddy-boy-mint.herokuapp.com/">Get now !</a>
                </span>
              </button>
            </div>
          </div>
          <div className=" relative bg-[#56B8FF] min-h-screen w-[37%] xl:w-[27%] flex items-center justify-start lg:hidden">
            <div className="min-h-[566px] min-w-[444px] ml-[-177px] rounded-[132px] bg-[#FFFFFF] flex justify-center items-center">
              <div className="min-w-[402px] min-h-[512px] bg-[#DBEFFF] rounded-[132px]"></div>
            </div>
            <div className="absolute w-[402px] ml-[-156px] bg-transparent rounded-[132px] overflow-hidden">
              <img
                src={warrior}
                className="min-h-[511px] min-w-[456px] ml-[-39px] rounded-[132px]"
                alt="warrior"
              />
            </div>
          </div>
        </div>

        {/*All people*/}
        <div>
          <img
            src={allWarriors}
            className="min-w-screen mix-blend-multiply w-full h-full"
            alt="allWarriors"
          />
        </div>

        {/*Roadmap */}

        <div
          className="flex justify-center opacity-95 bg-[url('./assets/images/frogBg.png')] bg-cover"
          id="roadmap_section"
        >
          <div className="min-w-screen m-14 md:m-0 md:p-[10%]">
            <div className=" m-1.5">
              <p className="not-italic text-2xl leading-7 text-[#57B9FF] sm:text-[16px]">
                Road map
              </p>
              <p className="not-italic text-6xl font-semibold leading-[104%] Toppan-text font-['toppan-bunkyu-midashi-go-std'] align-top tracking-wider text-[#FFFFFF] xl:text-[45px] xl:leading-[55px] md:text-[28px] md:leading-[36px] sm:text-[20px]  sm:leading-[30px]">
                From a Warrior to Legend <br /> Still Carry on.
              </p>
            </div>
            <div className="my-14 min-w-screen max-w-[1000px] grid gap-10 grid-cols-2 md:grid-cols-1	 text-left text-xl sm:text-[18px]">
              <div className="grid gap-5 grid-cols-1">
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/04:</p>
                  <p className="text-[#000000] font-[800]">
                    Cyber Warriors NFT series is on sale
                  </p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/05:</p>
                  <p className="text-[#000000] font-[800]">Establish a community system</p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/06:</p>
                  <p className="text-[#000000] font-[800]">
                    A unique actual gift would be given to the first guest of
                    each round buying Cyber Warriors NFT
                  </p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/07:</p>
                  <p className="text-[#000000] font-[800]">
                    Establish community spaces belonging to "Cyber Warriors " in
                    the metaverse worlds such as Sandbox and Decentraland
                  </p>
                </div>
              </div>
              <div className="grid gap-5 grid-cols-1">
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/08:</p>
                  <p className="text-[#000000] font-[800]">
                    Launching physical + virtual exhibition Launching "Cyber
                    Warriors " gang business series NFT
                  </p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/09:</p>
                  <p className="text-[#000000] font-[800]">
                    Collaborating with different Hong Kong Comic IP, building a
                    meta world together
                  </p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/10:</p>
                  <p className="text-[#000000] font-[800]">
                    Launching community governance token and NFT staking
                  </p>
                </div>
                <div className="bg-[#FFFFFF] rounded-3xl p-7 w-[100%]">
                  <p className="text-[#57B9FF]">2022/12:</p>
                  <p className="text-[#000000] font-[800]">
                    Establish a DAO system, and the community decides the
                    development of the project
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*The Story behind */}
        <div
          className=" bg-[#131820]"
          id="story_section"
        >
          <div className="max-w-[1600px] mx-auto relative min-w-screen z-10 grid gap-10 grid-cols-2 md:grid-cols-1 md:gap-0">
          <div className="grid-cols-1 my-auto h-screen  md:absolute md:left-50 md:opacity-10 md:h-[100%] -z-10 align-bottom">
            <img
              src={storyBehind}
              className="h-screen  md:h-[100%]"
              alt="storyBehind"
            />
          </div>
          <div className="grid-cols-1 md:w-[100%] flex items-center justify-center">
            <div className="p-7 md:pl-[10%] md:pr-[10%]  text-left">
              <p className="text-[#57B9FF]">Since 2022 to 2320</p>
              <p className="text-[#FFFFFF] Toppan-text text-6xl my-10 md:my-[10px] font-semibold tracking-[2px] xl:text-[45px] xl:leading-[55px] md:text-[28px] md:leading-[36px] sm:text-[20px]  sm:leading-[30px]">
                The Story behind
              </p>
              <p className="text-[#FFFFFF] text-xl sm:text-[16px]">
                “Cyber Warriors” is a triad-themed Hong Kong comic. The content
                of the story focuses on the expression of "brotherhood" and "the
                righteousness of the rivers and lakes". It was published on
                April 16, 1992, and the last issue was published on April 30,
                2020. A total of 2335 issues have experienced 28 years of
                history. It is the world's largest number of long-term unit
                story comics
              </p>
            </div>
          </div>
          </div>
        </div>

        {/*From comics */}
        <div className="bg-white relative font-['Sukhumvit Set'] flex ">
          <div className="min-w-screen max-w-[1600px] mx-auto min-h-0 grid gap-10 grid-cols-3 md:grid-cols-1">
            <div className="col-span-2 ">
              <p className="text-black m-[100px]  text-xl indent-0 text-left font-bold md:m-0 md:p-[10%] sm:text-[16px]">
                From comics to movies, the story of "Cyber Warriors "
                accompanies many Hong Kong people and even global Chinese to
                grow together and witness the constant changes of the world
                environment. After the end of the comic, we are also thinking
                about how to continue the inheritance of "Cyber Warriors ". So
                this year we decided to launch the "Young and Dangerous" NFT
                series to bring the culture and ideas of "Young and Dangerous"
                to the Metaverse, and continue to promote the development of
                Hong Kong comics based on the development of Web3.0.
              </p>
            </div>
            <div className="grid-cols-1 flex justify-center items-center md:absolute md:top-[50%] md:bottom-[50%] md:opacity-40 align-middle my-auto">
              <img
                src={headerIcon}
                className="min-w-screen mix-blend-multiply "
                alt="headerIcon"
              />
            </div>
          </div>
        </div>

        {/*Limited editions */}
        <div className=" flex relative overflow-hidden row z-10 justify-center font-['Sukhumvit Set'] bg-[#131820] text-left h-[1024px] md:h-[768px]">
          <div className="w-[calc(100%-544px)] max-w-[1600px] flex justify-start items-center md:w-screen md:p-[10%]">
            <div className="ml-[102px] md:ml-0">
              <p className="not-italic text-1xl text-left leading-7 my-8 md:my-0 text-[#57B9FF]">
                Limited editions
              </p>
              <p className="not-italic text-left text-[75px] font-semibold Toppan-text leading-[120%] align-top text-[#FFFFFF] my-8 md:my-[10px] xl:text-[45px] xl:leading-[55px] lg:text-[28px] lg:leading-[36px] sm:text-[20px]  sm:leading-[30px]">
                Get your NFTs. <br /> Be the BOSS!
              </p>
              <p className="not-italic text-left text-[22px] leading-[110%] align-top tracking-wider text-[#FFFFFF] my-8 md:my-0 sm:text-[16px]">
                All are in limited additions and provides you access into our
                community of Teddyboy
              </p>
              <button className="bg-sky-400 hover:bg-sky-500 w-64 h-16 md:h-[50px] md:mt-8 md:w-[200px] md:text-[20px] px-5 py-2 text-lg leading-5 rounded-none font-semibold text-white">
                Explore
              </button>
            </div>
          </div>
          <div className="relative w-[544px] flex items-center justify-end md:absolute md:top-[50%] md:bottom-[50%] md:-z-10 md:opacity-20">
            <div className="absolute w-[444px] h-[566px] lg:w-[344px] lg:h-[466px] md:w-[100] rounded-[132px] bg-[#D8D8D8] opacity-[.16] border border-solid border-[#979797] box-border mix-blend-normal mr-[78px]"></div>
            <div className="absolute w-[402px] h-[512px] lg:w-[302px] lg:h-[412px] md:w-[90] rounded-[132px] bg-[#F9C523] mr-[99px]">
              <img
                src={bossNFT}
                className="min-w-[451px] h-[672px] mt-[-160px] ml-[-21px] lg:ml-[-41px]"
                alt="bossNFT"
              />
            </div>
          </div>
        </div>

        {/*NFT*/}
        <div
          className="relative bg-white flex font-['Sukhumvit Set'] justify-center opacity-95 "
          id="nft_section"
        >
          <div className="min-w-screen my-36 m-10">
            <div className=" m-1.5">
              <p className="not-italic text-6xl font-extrabold Toppan-text leading-[104%] align-top tracking-wider text-black xl:text-[45px] xl:leading-[55px] lg:text-[28px] lg:leading-[36px] sm:text-[20px]  sm:leading-[30px]">
                Cyber Warriors NFTs
              </p>
            </div>
            <div className="my-14 w-full grid gap-12 grid-cols-3 md:grid-cols-2 xs:grid-cols-1 text-left text-xl">
              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-[1px] w-full grid grid-cols-2 gap-none z-40">
                <div className="col-span-2 border-[1px] w-full h-fit">
                  <img
                    src={nft}
                    className=" mix-blend-multiply w-full h-20vh z-45"
                    alt="nft"
                  />
                </div>
                <div className="col-span-2 h-18 w-full px-14 py-4 z-40">
                  <div className="bg-[#29313a] border-2 border-amber-300 w-full h-24 -mt-10 z-50 text-center pt-4">
                    <span className="text-white">Name</span>
                    <span className="text-[#57B9FF] block">Rare</span>
                  </div>
                </div>
                <div className="col-span-2 h-18 w-full px-2 py-4">
                  <div className="flex">
                    <div className="w-[70%]">
                      <p>Price</p>
                      <img
                        src={ethereum}
                        className="min-w-screen mix-blend-multiply h-8 inline mr-4"
                        alt="ethereum"
                      />
                      <span className="font-bold">1 ETH</span>
                    </div>
                    <div className="w-[30%]">
                      <p>
                        Total
                        <br />
                        200/888
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="my-14 min-w-full flex justify-center text-left text-xl">
              <button className="bg-sky-400 hover:bg-sky-500 md:h-[50px]  md:w-[200px] md:text-[20px] self-center w-64 h-16 px-5 py-2 text-lg leading-5 rounded-none text-white my-8">
                Load more
              </button>
            </div>
          </div>
          <div className="absolute z-50 bg-[#131820] w-full h-full opacity-95 flex justify-center items-center">
            <p className="not-italic text-6xl font-extrabold Toppan-text leading-[104%] text-amber-200  md:text-[40px] sm:text-[20px]  sm:leading-[30px]">
              Coming Soon...
            </p>
          </div>
        </div>

        {/*Join Discord */}

        <div className="relative overflow-hidden bg-amber-200 h-100 flex justify-center opacity-95  font-['Sukhumvit Set'] items-center">
          <div className=" absolute h-screen top-0 w-[100%] flex flex-col">
            <div className="min-w-screen">
              <img
                src={communityBg}
                className="min-w-screen min-h-screen mix-blend-multiply blur-[2px] opacity-20"
                alt="communityBg"
              />
            </div>
          </div>

          <div className=" min-w-screen p-14">
            <div className=" m-1.5 ">
              <p className="not-italic font-extrabold text-6xl Toppan-text leading-[120%] align-top tracking-wider text-black xl:leading-[65px] lg:text-[28px] lg:leading-[36px] sm:text-[20px]  sm:leading-[30px]">
                Join the largest comic NFTs <br /> community
              </p>
              <button className="bg-[#7389DB]  text-white w-2/5 h-16 md:h-[60px]  md:w-[200px] md:text-[20px]  rounded-none my-8 inline-flex ">
                <div className="grid grid-cols-5 gap-2 font-mono text-white text-center items-center ">
                  <div className=" col-span-3 align-middle font-bold text-xl leading-6 ml-4">
                    Join Discord
                  </div>
                  <div className="align-center">
                    <img
                      src={discord}
                      className="min-w-screen mix-blend-multiply ml-5 h-16"
                      alt="discord"
                    />
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/*footer*/}
        
        <div
          className="relative flex justify-center  bg-[#131820] z-15 text-left "
          id="about_section"
        >
          <div className="flex justify-center  sm:flex-col text-white w-[80%]">
            <div className="mt-[30px] mr-auto w-[300px] sm:w-[100%] py-[50px] sm:py-0 sm:m-0">
              <div className="m-1.5">
                <img
                  src={headerIcon}
                  className="h-24 sm:mx-auto"
                  alt="headerIcon"
                />
                <p className="not-italic text-left text-1xl leading-[125%] align-top font-medium tracking-wider text-[#FFFFFF] mb-8 sm:m-0">
                  Lorem ipsum dolor amet, consectetur
                  <br />
                  adipiscing elit. Eget nisl nunc quam ac sed turpis volutpat.
                  Cursus sed massa non.
                </p>
              </div>
            </div>

            <div className="w-[calc(100%-400px)] sm:w-[100%] sm:grid sm:grid-cols-2 z-30 pt-[100px] m-1.5 sm:m-0 sm:pt-[20px] sm:pb-[20px]">
              <p className="not-italic text-left text-1xl font-semibold leading-[125%] align-top tracking-wider text-[#FFFFFF] my-6 sm:my-2 ">
                <a href="/#">Menu</a>
              </p>
              <p className="not-italic text-left text-1xl font-semibold leading-[125%] align-top tracking-wider text-[#FFFFFF] my-6 sm:my-2 ">
                <a href="/#about_section">About</a>
              </p>
              <p className="not-italic text-left text-1xl font-semibold leading-[125%] align-top tracking-wider text-[#FFFFFF] my-6 sm:my-2 ">
                <a href="/#nft_section">NFTs</a>
              </p>
              <p className="not-italic text-left text-1xl font-semibold leading-[125%] align-top tracking-wider text-[#FFFFFF] my-6 sm:my-2 ">
                <a href="/#story_section">Story</a>
              </p>
              <p className="not-italic text-left text-1xl font-semibold leading-[125%] align-top tracking-wider text-[#FFFFFF] my-4 sm:my-2 ">
                <a href="/#roadmap_section">Roadmap</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="text-sm leading-6 flex justify-center bg-[#131820]">
        <div className="pt-5 pb-8 border-t border-slate-400 sm:flex justify-center text-white w-[80%]">
          <p className="text-1xl font-semibold text-center">
            Copyright by 2022 Cyber Warriors.
          </p>
        </div>
      </footer>
    </>
  );
}

export default App;
